<template>
	<v-app>
		<v-main ref="main">
			<router-view></router-view>
		</v-main>

		<v-dialog v-model="$store.state.notification.show" width="500" v-if="$store.state.notification.title != 'Unknown error'">
			<v-card style="padding:20px;">
				<!-- <div style="display:flex;justify-content:space-between;">
					<h2 v-if="$store.state.notification.title && $store.state.notification.title.length > 15" style="margin-bottom:10px;">Whoops! {{$store.state.notification.title}}</h2>
					<h2 v-else style="margin-bottom:10px;">Whoops! ({{$store.state.notification.title}})</h2>
					<v-btn icon color="secondary" @click="closeNotification">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div> -->
				
				
				
				<!-- INSPARATION -->
				<div v-if="this.$router.app._route.params.experienceSlug=='medspabizuniversity'"
				class="text-center mb-5">
					<h2 style="margin-bottom: 10px; font-size: larger;"
					>Website Deactivated</h2>
				</div>

				<div class="text-center mb-5" v-else>
					<h2 style="margin-bottom: 10px; font-size: larger;"
					>Something Went Wrong</h2>
				</div>

				<template
					v-if="$store.state.notification.content && $store.state.notification.content.type == 'NOTIFICATION'"
				>
					<div class="text-center"
						style="color:#C42126;font-size:14px;"
						:key="index"
						v-for="(item, index) in $store.state.notification.content.fieldErrorList"
					>{{item}}</div>
					<div class="text-center"
						style="color:#ED5025;font-size:14px;"
						:key="index"
						v-for="(item, index) in $store.state.notification.content.errorList"
					>{{item}}</div>
					<div class="text-center"
						style="color:#E26026;font-size:14px;"
						:key="index"
						v-for="(item, index) in $store.state.notification.content.noticeList"
					>{{item}}</div>
				</template>
				<template v-else>
					<div class="text-center" style="color:#E26026;font-size:14px;">{{$store.state.notification.content}}</div>
				</template>

				<!-- INSPARATION -->
				<div v-if="this.$router.app._route.params.experienceSlug === 'medspabizuniversity'"
				class="text-center mt-5 mr-10 ml-10">
					<p style="font-size: 10px; font-weight: bold; margin: 0;">
						This website is no longer active. Please contact
					</p>
					<p style="font-size: 10px; font-weight: bold; margin: 0;">
						<span style="color:blue; text-decoration: underline;">
						<v-icon small style="vertical-align: middle; margin-right: 4px;"
						>mdi-email</v-icon>Info@InSPArationManagement.com
						</span>
					</p>
					<p style="font-size: 10px; font-weight: bold; margin: 0;">
						or visit
					</p>
					<p style="font-size: 10px; font-weight: bold; margin: 0;">
						<a href="https://insparationmanagement.com" 
						target="_blank" 
						style="color:blue; text-decoration: underline;">
						insparationmanagement.com
						</a>
					</p>
				</div>


				<div class="text-center mt-5 mr-10 ml-10" v-else>
					<p style="font-size: 10px; font-weight: bold;">If this issue persists please contact us through our email with a screenshot at <span 
					style="color:blue; text-decoration: underline;">support@v-unite.com</span></p>
				</div>

				<div style="text-align:center;margin-top:20px;">
					<v-btn color="#009ec1" @click="closeNotification">Close</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-overlay style="z-index: 999;" :value="$root.loader.value" opacity="0">
			<img
				:src="baseLocation + '/resource/image/loader.svg'"
				class="loader"
			/>
		</v-overlay>
	</v-app>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			baseLocation: axios.defaults.baseURL
		};
	},
	methods: {
		closeNotification() {
			this.$store.commit("hideNotification");
		}
	},
};
</script>